//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Stars',
  props: {
    score: {
      type: Number | String,
      default: 0,
    },
  },
  data(){
    return {
      starsWidth: 0,
    };
  },
  mounted(){
    this.setStarsWidth();
  },
  methods: {
    setStarsWidth(){
      const score = Number(this.score);

      this.starsWidth = ((score / 5) * 100).toFixed(2);
    },
  },
  watch: {
    score(cur){
      this.setStarsWidth()
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/Stars.vue